import { FlowPage } from 'src/lib/flow/FlowPage';
import { FlowQuestion } from 'src/lib/flow/FlowQuestion';

export const isEnabled = ({ answers, inputContext: { answerPrefills } }) => {
  const prefillsDwellingType = answerPrefills['home.dwelling_type']?.value;
  if (prefillsDwellingType === 'apartment_condo' || prefillsDwellingType === 'apartment') {
    return true;
  }

  const answersDwellingType = answers['home.dwelling_type'];
  if (answersDwellingType === 'apartment_condo' || answersDwellingType === 'apartment') {
    return true;
  }
  return false;
};

const entryTypePage: FlowPage = {
  slug: () => 'entry-type',
  title: () => 'Do you have a shared entryway?',
  isEnabled,
  autoAdvance: () => true,
  questions: (): FlowQuestion[] => [
    {
      key: 'home.entry_type',
      type: 'radio_single_select',
      options: [
        {
          label: 'No, I enter directly into the home from the outside',
          value: 'direct_entry',
        },
        {
          label: 'Yes, I enter through a lobby or past a doorman',
          value: 'shared_entrance_condo',
        },
      ],
    },
  ],
};

export default entryTypePage;
